import _ from 'lodash';

const SkeletonCards = (cardCount = 3, className = '') =>
  _.range(cardCount).map((e) => (
    <div
      className={`border border-gray-300 shadow rounded-md p-4 w-full mx-auto mb-5 h-40 ${className}`}
      key={e}
    >
      <div className="animate-pulse flex space-x-4">
        <div className="rounded-full bg-gray-400 h-12 w-12" />
        <div className="flex-1 space-y-4 py-1">
          <div className="h-4 bg-gray-400 rounded w-3/4" />
          <div className="space-y-2">
            <div className="h-4 bg-gray-400 rounded" />
            <div className="h-4 bg-gray-400 rounded w-5/6" />
          </div>
        </div>
      </div>
    </div>
  ));

export default SkeletonCards;
